import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom'

import UserSession from './containers/user-session'

import Landing from './components/common/landing'
import Login from './containers/login'
import Register from './containers/register'
import Verify from './containers/verify'
import Join from './containers/join'
import Dashboard from './containers/dashboard'
import Library from './containers/library'
import Rider from './containers/rider'
import Event from './containers/event'
import NotFound from './components/common/not-found'
import Professionals from './components/common/professionals'

import './stylesheets/main.css'

class App extends Component {
  render() {
    const { userSession } = this.props

    return (
      <div className="app">
        <Router>
          <Switch>
            <Route    exact path="/" component={Landing} />
            <Route    exact path="/login" component={UserSession(Login)} />
            <Route    exact path="/register" component={UserSession(Register)} />
            <Route    exact from="/get-started" component={() => {
              window.location.href = 'https://medium.com/ridline-com/tips-on-how-to-use-ridline-when-creating-your-tech-rider-875d88131a48'
              return null
            }} />
            <Route    exact path="/professionals/:status?" component={Professionals} />
            <Route    exact path="/for-professionals/:status?" component={Professionals} />

            <Route    exact path="/verify/:verificationCode" component={Verify} />
            <Route    exact path="/join/:joinCode" component={Join} />

            <Route    exact path="/library" component={UserSession(Dashboard)} />

            <Redirect exact from="/rider" to="/library" />
            <Route    exact path="/rider/:riderId/:section?" component={UserSession(Rider)} />

            <Redirect exact from="/event" to="/library" />
            <Route    exact path="/event/:eventId/stage" render={({match}) => <Redirect to={`/event/${match.params.eventId}`} />} />
            <Route    exact path="/event/:eventId/:section?" component={UserSession(Event)} />
            <Route    exact path="/event/:eventId/stage/:stageId/rider" render={({match}) => <Redirect to={`/event/${match.params.eventId}/stage/${match.params.stageId}`} />} />
            <Route    exact path="/event/:eventId/stage/:stageId/:section?" component={UserSession(Event)} />
            <Route    exact path="/event/:eventId/stage/:stageId/rider/:riderId/:section?" component={UserSession(Event)} />

            <Route          path="*" component={NotFound} />
          </Switch>
        </Router>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js